import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  customerCode: {
    type: "text", //required
    name: "customerCode", //required
    label: "Customer Code", //required
    errorMsg: "Customer Code is required.", //optional
    maxLength: 20, //optional
    tabIndex: 1,
    required: true,
    disabled: true,
  },
  warehouseCode: {
    type: "text",
    name: "warehouseCode",
    label: "Warehouse Code",
    required: true,
    errorMsg: "Warehouse Code is required.",
    disabled: true,
  },
  doNumber: {
    type: "text",
    name: "doNumber",
    label: "DO Number",
    maxLength: 20,
    disabled: true,
  },
  status: {
    type: "text",
    name: "status",
    label: "Status",
    disabled: true,
  },
  doType: {
    type: "text",
    name: "doType",
    label: "DO Type",
    required: true,
    errorMsg: "DO Type is required",
    disabled: true,
  },
  doDate: {
    type: "date",
    name: "doDate",
    label: "DO Date",
    required: true,
    errorMsg: "DO Date is required",
    disabled: true,
  },
  // shipping
  consigneeCode: {
    type: "select",
    name: "consigneeCode",
    label: "Consignee Code",
  },
  shipCompany: {
    type: "text",
    name: "shipCompany",
    label: "Company",
    maxLength: 100,
  },
  customerName: {
    type: "text",
    name: "customerName",
    label: "Customer Name",
    maxLength: 100,
    required: true,
    errorMsg: "Customer Name is required",
  },
  shipContact: {
    type: "text",
    name: "shipContact",
    label: "Contact",
    maxLength: 100,
  },
  shipAddress1: {
    type: "text",
    name: "shipAddress1",
    label: "Address 1",
    maxLength: 200,
    required: true,
    errorMsg: "Ship Address 1 is required",
  },
  shipAddress2: {
    type: "text",
    name: "shipAddress2",
    label: "Address 2",
    maxLength: 200,
  },
  shipPostcode: {
    type: "text",
    name: "shipPostcode",
    label: "Postcode",
    maxLength: 10,
    required: true,
    errorMsg: "Ship Postcode is required",
  },
  shipCity: {
    type: "text",
    name: "shipCity",
    label: "City",
    maxLength: 100,
    required: true,
    errorMsg: "Ship City is required",
  },
  shipState: {
    type: "text",
    name: "shipState",
    label: "State",
    maxLength: 100,
  },
  shipCountry: {
    type: "select",
    name: "shipCountry",
    label: "Country",
    maxLength: 100,
  },
  shipPhone: {
    type: "text",
    name: "shipPhone",
    label: "Phone",
    maxLength: 20,
    required: true,
    errorMsg: "Ship Phone is required",
  },
  shipEmail: {
    type: "text",
    name: "shipEmail",
    label: "Email",
    maxLength: 100,
  },
  // billing
  billCompany: {
    type: "text",
    name: "billCompany",
    label: "Company",
    maxLength: 100,
  },
  billContact: {
    type: "text",
    name: "billContact",
    label: "Contact",
    maxLength: 100,
  },
  billAddress1: {
    type: "text",
    name: "billAddress1",
    label: "Address 1",
    maxLength: 200,
  },
  billAddress2: {
    type: "text",
    name: "billAddress2",
    label: "Address 2",
    maxLength: 200,
  },
  billPostcode: {
    type: "text",
    name: "billPostcode",
    label: "Postcode",
    maxLength: 10,
  },
  billCity: {
    type: "text",
    name: "billCity",
    label: "City",
    maxLength: 100,
  },
  billState: {
    type: "text",
    name: "billState",
    label: "State",
    maxLength: 100,
  },
  billCountry: {
    type: "select",
    name: "billCountry",
    label: "Country",
    maxLength: 100,
  },
  billPhone: {
    type: "text",
    name: "billPhone",
    label: "Phone",
    maxLength: 20,
  },
  billEmail: {
    type: "text",
    name: "billEmail",
    label: "Email",
    maxLength: 100,
  },
  // carrier
  carrier: {
    type: "text",
    name: "carrier",
    label: "Carrier",
    maxLength: 20,
    disabled: true,
  },
  shipmentType: {
    type: "text",
    name: "shipmentType",
    label: "Shipment Type",
    disabled: true,
  },
  shippingZone: {
    type: "text",
    name: "shippingZone",
    label: "Shipping Zone",
    maxLength: 20,
    required: true,
    errorMsg: "Shipping Zone is required",
    disabled: true,
  },
  collectionPoint: {
    type: "text",
    name: "collectionPoint",
    label: "Collection Point",
    maxLength: 100,
    disabled: true,
  },
  referenceNo: {
    type: "text",
    name: "referenceNo",
    label: "Reference No",
    maxLength: 20,
    disabled: true,
  },
  poNo: {
    type: "text",
    name: "poNo",
    label: "PO No",
    maxLength: 20,
    disabled: true,
  },
  salesRepName: {
    type: "text",
    name: "salesRepName",
    label: "Sales Rep Name",
    maxLength: 50,
    disabled: true,
  },
  paymentTerm: {
    type: "text",
    name: "paymentTerm",
    label: "Payment Term",
    maxLength: 20,
    disabled: true,
  },
  handlingInstruction: {
    type: "text",
    name: "handlingInstruction",
    label: "Handling Instruction",
    maxLength: 300,
    disabled: true,
  },
  transportArrangment: {
    type: "text",
    name: "transportArrangment",
    label: "Transport Arrangement",
    maxLength: 20,
    disabled: true,
  },
  tSmallCarton: {
    type: "number",
    name: "tSmallCarton",
    label: "T Small Carton",
  },
  tMediumCarton: {
    type: "number",
    name: "tMediumCarton",
    label: "T Medium Carton",
    //prefix:"$"
  },
  tLargeCarton: {
    type: "number",
    name: "tLargeCarton",
    label: "T Large Carton",
    //prefix:"$"
  },
  tPallet: {
    type: "number",
    name: "tPallet",
    label: "T Pallet",
    //prefix:"$"
  },
  noOfPoint: {
    type: "number",
    name: "noOfPoint",
    label: "No Of Point",
    disabled: true,
    //prefix:"$"
  },
  printedBy: {
    type: "text",
    name: "printedBy",
    label: "Printed By",
    maxLength: 100,
    disabled: true,
    //prefix:"$"
  },
  remark: {
    type: "text",
    name: "remark",
    label: "Remark",
    maxLength: 300,
    disabled: true,
  },
  applyBilling: {
    type: "button",
    name: "applyBilling",
    label: "Apply Billing",
  },
};

const {
  customerCode,
  warehouseCode,
  doNumber,
  status,
  doType,
  doDate,
  consigneeCode,
  shipCompany,
  customerName,
  shipContact,
  shipAddress1,
  shipAddress2,
  shipPostcode,
  shipCity,
  shipState,
  shipCountry,
  shipPhone,
  shipEmail,
  billCompany,
  billContact,
  billAddress1,
  billAddress2,
  billPostcode,
  billCity,
  billState,
  billCountry,
  billPhone,
  billEmail,
  carrier,
  shipmentType,
  shippingZone,
  collectionPoint,
  referenceNo,
  poNo,
  salesRepName,
  paymentTerm,
  handlingInstruction,
  transportArrangment,
  tSmallCarton,
  tMediumCarton,
  tLargeCarton,
  tPallet,
  noOfPoint,
  printedBy,
  remark,
  applyBilling,
} = formField;

export const headerRender = [
  [doNumber, customerCode, warehouseCode, status],
  [doType, doDate],
  [
    {
      type: "fieldset",
      label: "Shipping",
      fieldsetRender: [
        [consigneeCode, shipCompany, customerName, shipContact],
        [shipAddress1, shipAddress2, shipPostcode, shipCity],
        [shipState, shipCountry, shipPhone, shipEmail],
        [applyBilling]
      ],
    },
  ],
  [
    {
      type: "fieldset",
      label: "Billing",
      fieldsetRender: [
        [billCompany, billContact],
        [billAddress1, billAddress2, billPostcode, billCity],
        [billState, billCountry, billPhone, billEmail],
      ],
    },
  ],
  [
    {
      type: "fieldset",
      label: "Carrier",
      fieldsetRender: [[shippingZone, shipmentType, carrier, collectionPoint]],
    },
  ],
  [referenceNo, poNo, salesRepName, paymentTerm],
  [handlingInstruction, transportArrangment,noOfPoint, printedBy ],
  [tSmallCarton, tMediumCarton,tLargeCarton, tPallet  ],
  [remark],
];

export const headerValues = getInitialValues(formField);

export const headerValidation = Yup.object().shape({
  [customerCode.name]: Yup.string().nullable().required(customerCode.errorMsg),
  [warehouseCode.name]: Yup.string().nullable().required(warehouseCode.errorMsg),
  [status.name]: Yup.string().nullable(),
  [doType.name]: Yup.string().nullable().required(doType.errorMsg),
  [doDate.name]: Yup.string().nullable().required(doDate.errorMsg),
  // shipping
  [consigneeCode.name]: Yup.string().nullable(),
  [shipCompany.name]: Yup.string().nullable().max(shipCompany.maxLength),
  [customerName.name]: Yup.string()
    .nullable()
    .max(customerName.maxLength)
    .required(customerName.errorMsg),
  [shipContact.name]: Yup.string().nullable().max(shipContact.maxLength),
  [shipAddress1.name]: Yup.string()
    .nullable()
    .max(shipAddress1.maxLength)
    .required(shipAddress1.errorMsg),
  [shipAddress2.name]: Yup.string().nullable().max(shipAddress2.maxLength),
  [shipPostcode.name]: Yup.string()
    .nullable()
    .max(shipPostcode.maxLength)
    .required(shipPostcode.errorMsg),
  [shipCity.name]: Yup.string().nullable().max(shipCity.maxLength).required(shipCity.errorMsg),
  [shipState.name]: Yup.string().nullable().max(shipState.maxLength),
  [shipCountry.name]: Yup.string().nullable().max(shipCountry.maxLength),
  [shipPhone.name]: Yup.string().nullable().max(shipPhone.maxLength).required(shipPhone.errorMsg),
  [shipEmail.name]: Yup.string().nullable().max(shipEmail.maxLength),
  // billing
  [billCompany.name]: Yup.string().nullable().max(billCompany.maxLength),
  [billContact.name]: Yup.string().nullable().max(billContact.maxLength),
  [billAddress1.name]: Yup.string().nullable().max(billAddress1.maxLength),
  [billAddress2.name]: Yup.string().nullable().max(billAddress2.maxLength),
  [billPostcode.name]: Yup.string().nullable().max(billPostcode.maxLength),
  [billCity.name]: Yup.string().nullable().max(billCity.maxLength),
  [billState.name]: Yup.string().nullable().max(billState.maxLength),
  [billCountry.name]: Yup.string().nullable().max(billCountry.maxLength),
  [billPhone.name]: Yup.string().nullable().max(billPhone.maxLength),
  [billEmail.name]: Yup.string().nullable().max(billEmail.maxLength),
  // carrier
  [carrier.name]: Yup.string().nullable().max(carrier.maxLength),
  [shipmentType.name]: Yup.string().nullable(),
  [shippingZone.name]: Yup.string()
    .nullable()
    .max(shippingZone.maxLength)
    .required(shippingZone.errorMsg),
  [collectionPoint.name]: Yup.string().nullable().max(collectionPoint.maxLength),
  //
  [referenceNo.name]: Yup.string().nullable().max(referenceNo.maxLength),
  [poNo.name]: Yup.string().nullable().max(poNo.maxLength),
  [salesRepName.name]: Yup.string().nullable().max(salesRepName.maxLength),
  [paymentTerm.name]: Yup.string().nullable().max(paymentTerm.maxLength),
  [handlingInstruction.name]: Yup.string().nullable().max(handlingInstruction.maxLength),
  [remark.name]: Yup.string().nullable().max(remark.maxLength),
});
